import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} GoLiveStatusResponse
 * @property {boolean} can_go_live
 * @property {boolean} has_go_lived
 * @property {string} cycle_year
 * @property {string | null} reason
 */

export const useGoLiveStatus = () => {
  const [data, setData] = useState(
    /** @type {GoLiveStatusResponse | null} */ (null),
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  const getGoLiveStatus = async () => {
    try {
      setLoading(true);
      setError("");

      const url = `${TENANT_DOMAIN}/billing/subscription-cycles/go-live-status`;

      const response = await axiosInstance.get(url);

      const responseData = response?.data ?? null;

      setData(responseData);

      // ✅ ADD THIS (non-breaking)
      return { success: true, data: responseData };
    } catch (err) {
      setData(null);

      let message;

      if (err?.response?.status === 500) {
        message = ERROR_MESSAGES.INTERNAL_SERVER;
      } else {
        message = err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN;
      }

      setError(message);

      // ✅ ADD THIS (non-breaking)
      return { success: false, message };
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    loading,
    error,
    getGoLiveStatus,
  };
};
